/**
 * BillingPeriodToggle - Monthly/yearly billing period switcher
 */

import React from 'react';
import { Badge } from '@/components/ui/Badge';

interface BillingPeriodToggleProps {
  period: 'monthly' | 'yearly';
  onChange: (period: 'monthly' | 'yearly') => void;
  savingsPercent?: number;
}

export const BillingPeriodToggle: React.FC<BillingPeriodToggleProps> = ({
  period,
  onChange,
  savingsPercent = 17,
}) => {
  return (
    <div
      role="group"
      aria-label="Billing period"
      className="flex items-center justify-center gap-4 p-1 bg-gray-100 dark:bg-gray-800 rounded-lg w-fit mx-auto"
    >
      <button
        type="button"
        aria-pressed={period === 'monthly'}
        onClick={() => onChange('monthly')}
        className={`px-4 py-2 rounded-md transition-all ${
          period === 'monthly'
            ? 'bg-white dark:bg-gray-700 text-primary shadow-sm font-semibold ring-1 ring-primary/40'
            : 'text-gray-600 dark:text-gray-400 font-medium hover:text-gray-900 dark:hover:text-gray-200'
        }`}
      >
        Monthly
      </button>
      <button
        type="button"
        aria-pressed={period === 'yearly'}
        onClick={() => onChange('yearly')}
        className={`px-4 py-2 rounded-md transition-all flex items-center gap-2 ${
          period === 'yearly'
            ? 'bg-white dark:bg-gray-700 text-primary shadow-sm font-semibold ring-1 ring-primary/40'
            : 'text-gray-600 dark:text-gray-400 font-medium hover:text-gray-900 dark:hover:text-gray-200'
        }`}
      >
        Yearly
        <Badge variant="secondary" className="ml-1 bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100">
          Save {savingsPercent}%
        </Badge>
      </button>
    </div>
  );
};
